import React from "react";
import {
  HeadingText,
  HeadingBar,
  Modal,
  StackLayout,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { ModalActionButton } from "./modal-action-button.component";

interface Props {
  children: React.ReactNode;
  footer?: React.ReactNode;
  title?: string;
  maxWidth?: number;
  fullHeightOnMobile?: boolean;
}

export const BaseModalContainer = ({
  title,
  maxWidth = 583,
  children,
  footer = null,
  fullHeightOnMobile = false,
}: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal.Content
      showCloseButton={false}
      padding="$none"
      css={{
        ".GDS-modal-content": {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        ".GDS-modal": {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth,
          "@mobile": {
            maxWidth: "100%",
            ...(fullHeightOnMobile && {
              height: "100dvh",
              maxHeight: "100dvh",
              borderRadius: 0,
            }),
          },
        },
      }}
    >
      <HeadingBar
        trailingAction={
          <ModalActionButton
            actionType="close"
            buttonText={formatMessage({ id: "STR_CLOSE" })}
            css={{ border: "none" }}
          />
        }
        title={
          title ? (
            <Modal.Title>
              <HeadingText level="display" size="sm">
                {title}
              </HeadingText>
            </Modal.Title>
          ) : null
        }
      />
      <StackLayout
        css={{
          flexGrow: 1,
          textAlign: "left",
          "@mobile": {
            textAlign: "center",
          },
        }}
        spacing="$half"
        horizontalAlignment="center"
      >
        <StackLayout
          spacing="$half"
          horizontalAlignment="stretch"
          css={{
            padding: "$oneAndHalf",
            paddingTop: "$none",
            width: "100%",
          }}
        >
          {children}
          {footer}
        </StackLayout>
      </StackLayout>
    </Modal.Content>
  );
};
